/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TrustCommercepatientBillingsPatientBilling from './TrustCommercepatientBillingsPatientBilling';

/**
 * The TrustCommercePatientBillingsBody model module.
 * @module model/TrustCommercePatientBillingsBody
 * @version v0.3
 */
export default class TrustCommercePatientBillingsBody {
  /**
   * Constructs a new <code>TrustCommercePatientBillingsBody</code>.
   * @alias module:model/TrustCommercePatientBillingsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TrustCommercePatientBillingsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TrustCommercePatientBillingsBody} obj Optional instance to populate.
   * @return {module:model/TrustCommercePatientBillingsBody} The populated <code>TrustCommercePatientBillingsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TrustCommercePatientBillingsBody();
      if (data.hasOwnProperty('patient_billing'))
        obj.patientBilling = TrustCommercepatientBillingsPatientBilling.constructFromObject(data['patient_billing']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TrustCommercepatientBillingsPatientBilling} patientBilling
 */
TrustCommercePatientBillingsBody.prototype.patientBilling = undefined;

